export const getPlayerUrl = (recItem) => 
    `/recording/player/${recItem.id}`;